import { LandingContext } from 'common/contexts/Landing/Landing'
import { baseURL } from 'models'
import { Styled } from 'components/Styled'
import { useContext, useRef } from 'react'
import { Settings } from 'react-slick'
import SlickSlider from 'react-slick'
import { useResolution } from 'common/hooks'
import {
  ButtonSlider,
  ButtonWrapperLeft,
  ButtonWrapperRight,
  Container,
  ImageArrow,
  ImageContainer,
  ImageSwiper,
  MiddleLine,
  Section,
  StyledButtonWrapperMob,
  SwiperContainer,
} from './styled'
import { Svg } from 'common/assets'
import { useLocation } from 'react-router-dom'

export const Decoration = () => {
  const slider = useRef<SlickSlider>(null)
  const { pathname } = useLocation()
  const isBanquet = pathname.includes('banquet')
  const { isMinScreen1000 } = useResolution()
  const { landing } = useContext(LandingContext)
  const pictures = landing?.mainSlider
  const images = !isBanquet ? [...pictures] : [...landing.banketGallery]

  const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    arrows: false,
    centerMode: true,
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 449,
        settings: {
          slidesToShow: 1,
          infinite: true,
          centerMode: false,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 2000,
          cssEase: 'linear',
        },
      },
    ],
  }

  const handleClickPrev = () => {
    slider.current?.slickPrev()
  }

  const handleClickNext = () => {
    slider.current?.slickNext()
  }

  return (
    <Section>
      <Container>
        {/* Title */}

        {/* Slider */}
        <div style={{ width: '100%', position: 'relative' }}>
          <SwiperContainer {...settings} ref={slider}>
            {images.map((image, index) => (
              // Slide
              <ImageContainer key={index}>
                <ImageSwiper
                  src={
                    isBanquet
                      ? `${baseURL}/public/${image}`
                      : `${baseURL}/${image}`
                  }
                  alt="image restaurant"
                />
              </ImageContainer>
            ))}
          </SwiperContainer>
          <ButtonWrapperLeft>
            <ButtonSlider
              position={'left'}
              name="prev"
              className="prev"
              onClick={handleClickPrev}>
              <ImageArrow>
                <use href={Svg.sprite + '#icon-arrow'} />
              </ImageArrow>
            </ButtonSlider>
          </ButtonWrapperLeft>

          <ButtonWrapperRight>
            <ButtonSlider
              type="button"
              position={'right'}
              name="next"
              className="next"
              onClick={handleClickNext}>
              <ImageArrow>
                <use href={Svg.sprite + '#icon-arrow'} />
              </ImageArrow>
            </ButtonSlider>
          </ButtonWrapperRight>

          {!isMinScreen1000 && (
            <StyledButtonWrapperMob>
              <MiddleLine />
              <Styled.FlexWrapper gap={22}>
                <ButtonSlider
                  type="button"
                  position={'left'}
                  name="prev"
                  className="prev"
                  onClick={handleClickPrev}>
                  <ImageArrow>
                    <use href={Svg.sprite + '#icon-arrow'} />
                  </ImageArrow>
                </ButtonSlider>
                <ButtonSlider
                  type="button"
                  position={'right'}
                  name="next"
                  className="next"
                  onClick={handleClickNext}>
                  <ImageArrow>
                    <use href={Svg.sprite + '#icon-arrow'} />
                  </ImageArrow>
                </ButtonSlider>
              </Styled.FlexWrapper>
            </StyledButtonWrapperMob>
          )}
        </div>
      </Container>
    </Section>
  )
}
